import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.css']
})
export class CguComponent implements OnInit {

  @Output()
  closeCguEventEmitter: EventEmitter<any>;

  constructor() {
    this.closeCguEventEmitter = new EventEmitter();
  }

  ngOnInit() {
  }

  onCloseCgu() {
    this.closeCguEventEmitter.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/cgu/cgu.component.ts